import React, { useEffect, useState } from "react";
import configs, { getParameterByName } from "../Constants";
import axios from "axios";
import { useIntl } from "react-intl";
import { useNavigate } from "react-router-dom";
import { Pie } from "react-chartjs-2";
import {
  Chart as ChartJS,
  Title,
  Tooltip,
  Legend,
  ArcElement,
  CategoryScale,
  LinearScale,
} from "chart.js";
import { Table, Thead, Tbody, Tr, Th, Td } from "react-responsive-list";
import Card from "@mui/material/Card";
import CardActions from "@mui/material/CardActions";
import CardContent from "@mui/material/CardContent";
import Button from "@mui/material/Button";
import Typography from "@mui/material/Typography";
import DeliveryDiningIcon from "@mui/icons-material/DeliveryDining";
import Tabs from "@mui/material/Tabs";
import moment from "moment-timezone";
import Tab from "@mui/material/Tab";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import CloseIcon from "@mui/icons-material/Close";
import Dialog from "@mui/material/Dialog";
import DialogTitle from "@mui/material/DialogTitle";
import DialogContent from "@mui/material/DialogContent";
import DialogActions from "@mui/material/DialogActions";
import IconButton from "@mui/material/IconButton";
import Paper from "@mui/material/Paper";
import { Box, getToolbarUtilityClass } from "@mui/material";
import ButtonGroup from "@mui/material/ButtonGroup";
import Currencies from "../root/currency";
import { timeSince } from "../root/util";
import { ToastContainer, toast } from "react-toastify";
import ChartDataLabels from "chartjs-plugin-datalabels"; // Import the datalabels plugin
import TextField from "@mui/material/TextField";

// Register Chart.js components
ChartJS.register(
  Title,
  Tooltip,
  Legend,
  ArcElement,
  CategoryScale,
  LinearScale,
  ChartDataLabels // Register the plugin here
);

const Dashboard = () => {
  const [orderList, setOrderList] = useState([]);
  const [products, setProducts] = useState(0);
  const [categories, setCategories] = useState(0);
  const [fromDate, setFromDate] = useState();
  const [toDate, setToDate] = useState();
  const [report, setReport] = useState([]);
  const [value, setValue] = React.useState(1);
  const [branchId, setBranchId] = useState(localStorage.getItem("selectedBranchId"));
  const [inventoryData, setInventoryData] = useState([]);
  const [allUsers, setAllUsers] = useState([]);
  const [settings, setSettings] = useState([]);
  const [inventoryTab, setInventoryTab] = useState(0);
  const [merchantTab, setMerchantTab] = useState(0);
  const [userSearch, setUserSearch] = useState("");
  const memberPath = `/members`;
  const [inventoryMetrics, setInventoryMetrics] = useState({
    belowLimit: [],
    almostFinished: 0,
    nearExpiry: 0
  });
  const [branchData, setBranchData] = useState({
    totalBranches: 0,
    newBranchesLastMonth: 0,
    newBranchesLast3Months: 0
  });
  const [paymentBreakdown, setPaymentBreakdown] = useState({
    UPI: 0,
    Cash: 0,
    Card: 0,
    Coupons: 0,
  });
  const [orderTypeBreakdown, setOrderTypeBreakdown] = useState({
    "Eat In": 0,
    "Take Away": 0,
    "Table Order": 0,
    Delivery: 0,
  });
  const tdStyle = {
    padding: "10px",
    border: "1px solid #ddd",
    textAlign: "center",
  };
  const thStyle = {
    padding: "12px",
    border: "1px solid #ddd",
    textAlign: "center",
    fontWeight: "bold"

  };

  //const [showBelowLimitPopup, setShowBelowLimitPopup] = useState(false);
  const [belowLimitItemsDetails, setBelowLimitItemsDetails] = useState([]);
  // const [showAlmostFinishedPopup, setShowAlmostFinishedPopup] = useState(false); 
  const [almostFinishedItemsDetails, setAlmostFinishedItemsDetails] = useState([]);
  // const [showNearExpiryPopup, setShowNearExpiryPopup] = useState(false);
  const [nearExpiryItemsDetails, setNearExpiryItemsDetails] = useState([]);
  const [mostOrderedItems, setMostOrderedItems] = useState([]);
  const [branchSetts, setBranchSetts] = useState([]);
  const [franchiseBranchCounts, setFranchiseBranchCounts] = useState({});
  const [userProfileDialogOpen, setUserProfileDialogOpen] = useState(false);
  const [linkedVendors, setLinkedVendors] = useState([]);
  const [isLoadingLinked, setIsLoadingLinked] = useState(false);
  const [showLinkModal, setShowLinkModal] = useState(false);
  const [merchantCodeToLink, setMerchantCodeToLink] = useState("");
  const [isLinking, setIsLinking] = useState(false);
  const { formatMessage: t, locale, setLocale } = useIntl();
  const navigate = useNavigate();

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  // useEffect(() => {
  //   const today = new Date();
  //   const yesterday = new Date(today);
  //   yesterday.setDate(yesterday.getDate() - 1);

  //   if (value === 0) {
  //     setFromDate(yesterday.toISOString().split("T")[0]);
  //     setToDate(yesterday.toISOString().split("T")[0]);
  //   } else if (value === 1) {
  //     setFromDate(today.toISOString().split("T")[0]);
  //     setToDate(today.toISOString().split("T")[0]);
  //   }
  // }, [value]);

  let baseURL = configs.baseURL;
  let staticSer = configs.staticSer;

  let userData = localStorage.getItem("userData")
    ? JSON.parse(localStorage.getItem("userData"))
    : "";
  const token = localStorage.getItem("token");
  console.log(userData);
  let merchantData = localStorage.getItem("merchantData")
    ? JSON.parse(localStorage.getItem("merchantData"))
    : null;
  const userId = userData ? userData.sub : " ";
  const merchCode = merchantData ? merchantData.merchantCode : "";
  console.log("dashboard", merchCode);
  const getDashboardData = `${baseURL}/api/dashboard?merchantCode=${merchCode}`;
  //const getProductByUser = baseURL + `/api/products?merchantCode=${merchCode}`;
  //const getCatByUser = `${baseURL}/api/categories?merchantCode=${merchCode}`;
  let cur = userData ? userData.currency : "";
  let currency = Currencies.filter(
    (curen) => curen.abbreviation == merchantData?.currency
  );
  let SelectCurrency = currency && currency[0] ? currency[0].symbol : "";
  console.log(SelectCurrency);
  const selectedCurrency = (
    <span dangerouslySetInnerHTML={{ __html: SelectCurrency }} />
  );
  console.log(selectedCurrency);
  const formatter = new Intl.NumberFormat(localStorage.getItem("locale") || 'en-US', {
    style: 'currency',
    currency: merchantData?.currency || 'USD'
  });
  const showPaymentSummary = (orders) => {
    const paymentCount = {
      UPI: { count: 0, total: 0 },
      Cash: { count: 0, total: 0 },
      Card: { count: 0, total: 0 },
      Coupons: { count: 0, total: 0 },
    };

    orders && orders.forEach((order) => {
      const isRefund = order.orderType?.toLowerCase() === "refund";
      if (order.payVia === "UPI") {
        paymentCount.UPI.count++;
        paymentCount.UPI.total += isRefund ? -order.totalPrice : order.totalPrice;
      } else if (order.payVia === "CASH") {
        paymentCount.Cash.count++;
        paymentCount.Cash.total += isRefund ? -order.totalPrice : order.totalPrice;
      } else if (order.payVia === "CARD") {
        paymentCount.Card.count++;
        paymentCount.Card.total += isRefund ? -order.totalPrice : order.totalPrice;
      }
    });

    setPaymentBreakdown(paymentCount);
  }


  const showInventorySummary = (inventoriesList) => {
    // Calculate inventory metrics based on the actual data structure
    const belowLimit = inventoriesList && inventoriesList
      .filter(item => item.availableQnty < item.minLimit)
      .map(item => ({
        name: item.name,
        availableQnty: item.availableQnty,
        minLimit: item.minLimit
      }));

    // Items that are almost finished
    const almostFinishedItems = inventoriesList && inventoriesList.filter(item => {
      if (item.minLimit < 1) {
        return item.availableQnty <= 5;
      }
      return item.availableQnty <= item.minLimit * 1.2;
    });

    // Items expiring in the next 30 days
    const nearExpiryItems = inventoriesList && inventoriesList.filter(item => {
      if (!item.expiryDate) return false;

      const expiryDate = new Date(item.expiryDate);
      const today = new Date();
      const diffTime = Math.abs(expiryDate - today);
      const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));
      return diffDays <= 30;
    });

    setInventoryMetrics({
      belowLimit: belowLimit && belowLimit.map(item => item.name),
      almostFinished: almostFinishedItems?.length,
      nearExpiry: nearExpiryItems?.length
    });
    setBelowLimitItemsDetails(belowLimit);
    setAlmostFinishedItemsDetails(almostFinishedItems);
    setNearExpiryItemsDetails(nearExpiryItems);
  }

  const showOrderTypeSummary = (orders) => {
    const orderTypeCount = {
      "Eat In": 0,
      "Take Away": 0,
      "Table Order": 0,
      "Delivery": 0,
      "Refund": 0,
    };

    // Loop through the report data to count each order type
    orders && orders.forEach((order) => {
      if (order.orderType === "Eat In") orderTypeCount["Eat In"]++;
      else if (order.orderType === "Take Away")
        orderTypeCount["Take Away"]++;
      else if (order.orderType === "Table Order")
        orderTypeCount["Table Order"]++;
      else if (order.orderType === "Delivery")
        orderTypeCount["Delivery"]++;
      else if (order.orderType?.toLowerCase() === "refund")
        orderTypeCount["Refund"]++;
    });

    // Set the order type breakdown
    setOrderTypeBreakdown(orderTypeCount);
  }

  useEffect(() => {
    axios.get(getDashboardData, {
      headers: {
        'Authorization': `Bearer ${token}`
      }
    }).then((response) => {
      console.log(response);
      setBranchSetts(response.data.branches);
      let startDate, endDate;

      startDate = moment().tz(merchantData?.timezone || moment.tz.guess()).startOf("day");
      endDate = moment().tz(merchantData?.timezone || moment.tz.guess()).endOf("day");

      //startDate = startDate.format("YYYY-MM-DD");
      //endDate = endDate.format("YYYY-MM-DD");
      let tzRes = (response.data?.orders || []).map(rp => { rp.createdAt = moment(rp.createdAt).tz(merchantData?.timezone || moment.tz.guess()); return rp });
      let recents = tzRes.filter((item) => {
        const itemTime = new Date(item.createdAt).getTime();
        const fromTime = new Date(startDate).getTime();
        const toTime = new Date(endDate).getTime() + 86400000;
        return itemTime >= startDate && itemTime < endDate;
      });
      setOrderList(recents);
      showPaymentSummary(recents);
      setReport(recents);
      showOrderTypeSummary(recents);
      aggregateMostOrderedItems(recents);
      setProducts(response.data.products);
      setCategories(response.data.categories);
      setInventoryData(response.data.inventories);
      showInventorySummary(response.data.inventories);
      setSettings(response.data.settings);
      let merchs = [];
      response.data?.branches?.filter(br => br.merchantCode && merchs.push(br.merchantCode));
      console.log(merchs);
      localStorage.setItem('branch-merchants', JSON.stringify(merchs));
    });

  }, []);


  const imageOnErrorHandler = (event) => {
    event.currentTarget.src = "/images/blank.jpg";
  };

  const fetchAllUserData = async () => {
    try {

      const authApiServer = configs.authapi;
      const userId = userData ? userData.sub : " ";

      if (userId && userId !== " ") {
        const response = await axios.get(`${authApiServer}/user/admin/super`, {
          headers: {
            'Authorization': `Bearer ${token}`
          }
        });
        console.log(response.data);
        setAllUsers(response.data.reverse());

      }
    } catch (error) {
      console.error("Error fetching user data:", error);
    }
  }

  useEffect(() => {
    console.log(userData);
    if (userData && userData.role.toUpperCase() === "SUPER-ADMIN") {
      fetchAllUserData();
    }
    if (userData && userData.role.toUpperCase() === "MULTIVENDOR-ADMIN") {
      fetchLinkedVendors();
    }

  }, []);



  // Fetch branch data when component mounts
  const fetchBranchData = async () => {
    try {

      const authApiServer = configs.authapi;
      const userId = userData ? userData.sub : " ";

      if (userId && userId !== " ") {
        const response = await axios.get(`${authApiServer}/user/members?userid=${userId}`, {
          headers: {
            'Authorization': `Bearer ${token}`
          }
        });

        // Filter out IAM users to get only branches
        const branches = response.data.filter(member => !member.isIAM);

        // Calculate metrics
        const totalBranches = branches.length;

        // Calculate branches added last month
        const lastMonthDate = new Date();
        lastMonthDate.setMonth(lastMonthDate.getMonth() - 1);

        const branchesLastMonth = branches.filter(branch => {
          const createdDate = new Date(branch.createdDate);
          return createdDate >= lastMonthDate;
        }).length;

        // Calculate branches added in last 3 months
        const last3MonthsDate = new Date();
        last3MonthsDate.setMonth(last3MonthsDate.getMonth() - 3);

        const branchesLast3Months = branches.filter(branch => {
          const createdDate = new Date(branch.createdDate);
          return createdDate >= last3MonthsDate;
        }).length;

        setBranchData({
          totalBranches,
          newBranchesLastMonth: branchesLastMonth,
          newBranchesLast3Months: branchesLast3Months,
          branches: branches.reverse() || []

        });
      }
    } catch (error) {
      console.error("Error fetching branch data:", error);
    }
  };

  useEffect(() => {
    if (userData && userData.role.toUpperCase() === "FRANCHISE-ADMIN") {
      fetchBranchData();
    }

  }, []);

  const fetchLinkedVendors = async () => {
    if (userData && userData.role.toUpperCase() === "MULTIVENDOR-ADMIN") {
      setIsLoadingLinked(true);
      try {
        const response = await axios.get(`${configs.authapi}/user/linked-vendors?userId=${userData.sub}`, {
          headers: {
            'Authorization': `Bearer ${token}`
          }
        });
        setLinkedVendors(response.data || []);
      } catch (error) {
        console.error("Error fetching linked vendors:", error);
      } finally {
        setIsLoadingLinked(false);
      }
    }
  };

  const handleLinkVendor = async (e) => {
    if (e) e.preventDefault();
    if (!merchantCodeToLink) {
      toast.error("Merchant Code is required");
      return;
    }
    setIsLinking(true);
    try {
      await axios.post(`${configs.authapi}/user/link-vendor`, {
        merchantCode: merchantCodeToLink,
        parentUserId: userData.sub
      }, {
        headers: {
          'Authorization': `Bearer ${token}`
        }
      });
      toast.success("Vendor linked successfully");
      setShowLinkModal(false);
      setMerchantCodeToLink("");
      fetchLinkedVendors();
    } catch (error) {
      console.error("Error linking vendor:", error);
      toast.error(error.response?.data?.message || "Failed to link vendor");
    } finally {
      setIsLinking(false);
    }
  };

  const handleUnlinkVendor = async (code) => {
    if (!window.confirm(`Are you sure you want to unlink vendor ${code}?`)) return;
    try {
      await axios.post(`${configs.authapi}/user/unlink-vendor`, {
        merchantCode: code,
        parentUserId: userData.sub
      }, {
        headers: {
          'Authorization': `Bearer ${token}`
        }
      });
      toast.success("Vendor unlinked successfully");
      fetchLinkedVendors();
    } catch (error) {
      console.error("Error unlinking vendor:", error);
      toast.error(error.response?.data?.message || "Failed to unlink vendor");
    }
  };

  // Fetch branch counts for all franchise admins (for SUPER-ADMIN)
  const fetchFranchiseBranchCounts = async () => {
    try {
      const authApiServer = configs.authapi;
      const franchiseAdmins = allUsers.filter(usr =>
        usr.role && usr.role.toUpperCase() === "FRANCHISE-ADMIN"
      );

      const counts = {};

      await Promise.all(
        franchiseAdmins.map(async (franchise) => {
          try {
            const response = await axios.get(`${authApiServer}/user/members?userid=${franchise.id}`, {
              headers: {
                'Authorization': `Bearer ${token}`
              }
            });
            const branches = response.data.filter(member => !member.isIAM);
            counts[franchise.id] = branches.length;
          } catch (error) {
            console.error(`Error fetching branches for franchise ${franchise.id}:`, error);
            counts[franchise.id] = 0;
          }
        })
      );

      setFranchiseBranchCounts(counts);
    } catch (error) {
      console.error("Error fetching franchise branch counts:", error);
    }
  };

  useEffect(() => {
    if (userData && userData.role.toUpperCase() === "SUPER-ADMIN" && allUsers.length > 0) {
      const hasFranchiseAdmins = allUsers.some(usr =>
        usr.role && usr.role.toUpperCase() === "FRANCHISE-ADMIN"
      );
      if (hasFranchiseAdmins) {
        fetchFranchiseBranchCounts();
      }
    }
  }, [allUsers]);

  // useEffect(() => {
  //   // Fetch inventory data when component mounts
  //   const fetchInventoryData = async () => {
  //     try {
  //       const userToken = localStorage.getItem("token");
  //       const response = await axios.get(
  //         `${baseURL}/api/inventories?merchantCode=${merchCode}`,
  //         { headers: { Authorization: `Bearer ${userToken}` } }
  //       );

  //       const inventory = response.data;
  //       setInventoryData(inventory);


  //     } catch (error) {
  //       console.error("Error fetching inventory data:", error);
  //     }
  //   };

  //   fetchInventoryData();
  // }, []);

  const aggregateMostOrderedItems = (orders) => {
    const orderCounts = {};

    console.log("orderdata", orders);

    orders && orders.forEach((order) => {
      const isRefund = order.orderType?.toLowerCase() === "refund";
      order.orderItems.forEach((item) => {
        let itemRevenue = item.select_type === "weight" ? (item.quantity / 1000 * item.price) : (item.quantity * item.price);
        itemRevenue = item.container_price ? itemRevenue + item.container_price : itemRevenue;
        if (orderCounts[item.name]) {
          orderCounts[item.name].quantity += isRefund ? -item.quantity : item.quantity;
          orderCounts[item.name].revenue += isRefund ? -itemRevenue : itemRevenue;
        } else {
          orderCounts[item.name] = {
            quantity: isRefund ? -item.quantity : item.quantity,
            revenue: isRefund ? -itemRevenue : itemRevenue,
          };
        }
      });
    });

    const sortedOrders = Object.entries(orderCounts)
      .sort((a, b) => b[1].quantity - a[1].quantity)
      .map(([name, { quantity, revenue }]) => ({
        name,
        quantity,
        revenue,
      }));

    console.log(sortedOrders);
    setMostOrderedItems(sortedOrders);
  };

  const pieChartData = {
    labels: [
      `Scans -  ${paymentBreakdown.UPI.total}`,
      `Cash -  ${paymentBreakdown.Cash.total}`,
      `Card -  ${(paymentBreakdown.Card.total)}`],
    datasets: [
      {
        label: "Payment Methods",
        data: [
          paymentBreakdown.UPI.count,
          paymentBreakdown.Cash.count,
          paymentBreakdown.Card.count,
        ],
        backgroundColor: ["#36A2EB", "#FF6384", "#FFCE56"],
        hoverOffset: 4,
      },
    ],
  };

  const options = {
    responsive: true,
    maintainAspectRatio: false,
    plugins: {
      legend: {
        position: "right",
        labels: {
          font: {
            size: 14,
            weight: "bold",
          },
          padding: 20,
          boxWidth: 20,
        },
      },
      datalabels: {
        display: true, // Show data labels
        color: "black", // Label color
        font: {
          size: 14, // Set the font size
          weight: "bold",
        },
        formatter: (value, context) => {
          return value === 0 ? "" : value;
        },
        anchor: "end", // Position the label at the end of the arc
        align: "start", // Align the label to the right of the pie chart
        offset: 10, // Offset from the pie chart
      },
    },
  };

  const orderTypePieChartData = {
    labels: ["Eat In", "Take Away", "Table Order", "Delivery"],
    datasets: [
      {
        label: "Order Types",
        data: [
          orderTypeBreakdown["Eat In"],
          orderTypeBreakdown["Take Away"],
          orderTypeBreakdown["Table Order"],
          orderTypeBreakdown["Delivery"],
        ],
        backgroundColor: ["#FF5733", "#33FF57", "#3380FF", "#F1C40F"],
        hoverOffset: 4,
      },
    ],
  };

  const orderOptions = {
    responsive: true,
    maintainAspectRatio: false,
    plugins: {
      legend: {
        position: "right",
        labels: {
          font: {
            size: 14,
            weight: "bold",
          },
          padding: 20,
          boxWidth: 20,
        },
      },
      datalabels: {
        display: true,
        color: "black",
        font: {
          size: 14,
          weight: "bold",
        },
        formatter: (value, context) => {
          return value === 0 ? "" : value;
        },
        anchor: "end",
        align: "start",
        offset: 10,
      },
    },
  };

  const randomString = (length, chars) => {
    var result = "";
    for (var i = length; i > 0; --i) {
      result += chars[Math.floor(Math.random() * chars.length)];
    }
    return result;
  }

  const generateMerchantCode = async (userId) => {
    let newMerchCode = randomString(
      10,
      "0123456789ABCDEFGHIJKLMNOPQRSTUVWXYZ"
    );

    if (!userId) return;
    const userToken = localStorage.getItem("token");
    try {
      let setData = {
        userId: userId,
        merchantCode: newMerchCode,
        activeProviderId: "",
        sokBGImg: "",
        activePaymentGateway: "",
        activeDeliveryPartner: "",
        currency: "INR",
        logoImg: "",
        onlyTakeAway: false,
        isLeftAlign: true,
        filterVegNonVeg: true,
        themeColor: "#f71919",
        themeTxtColor: "#fcad63",
        themePrimaryFontFam: "poppins",
        themeSecondaryFontFam: "poppins",
        customizeInWizard: true,
        dineinTax: 0,
        takeAwayTax: 5,
        notes: "",
        location: {
          type: "Point",
          coordinates: [12.2, 77.0],
        },
        openTime: 10,
        closeTime: 23,
      }
      let branchSet = await axios.post(
        `${baseURL}/api/settings`,
        setData,
        {
          headers: { Authorization: `Bearer ${userToken}` },
        });

      if (userData && userData.role.toUpperCase() == "FRANCHISE-ADMIN") {
        let newBranchSets = JSON.parse(JSON.stringify(branchSetts));
        newBranchSets.push(setData);
        setBranchSetts(newBranchSets);
        fetchBranchData();
      }
      if (userData && userData.role.toUpperCase() == "SUPER-ADMIN") {
        let newSets = JSON.parse(JSON.stringify(settings));
        newSets.push(setData);
        setSettings(newSets);
      }

    } catch (error) {
      console.error("Error updating settings:", error);
    }
  };


  const handleCloneMenu = async () => {
    try {
      const token = localStorage.getItem("token");

      const merchantDataObj = JSON.parse(localStorage.getItem("merchantData"));
      const merchantcode = merchantDataObj ? merchantDataObj.merchantCode : "";
      // console.log("Merchant code for cloning:", merchantcode);
      const cloneData = {
        sourceUserId: userId,
        targetUserId: branchId
      };

      const response = await axios.post(
        `${baseURL}/api/franchise/clone-menu/`,
        cloneData,
        {
          headers: {
            'Authorization': `Bearer ${token}`,
            'Content-Type': 'application/json'
          }
        }
      );

      if (response.status === 200) {
        toast.success("Menu cloned successfully!");
      } else {
        toast.error("Failed to clone menu. Please try again.");
      }
    } catch (error) {
      console.error("Error cloning menu:", error);
      toast.error("Failed to clone menu. Please try again.");
    }
  };
  console.log('------------');
  console.log(report);


  //let settings= JSON.parse(localStorage.getItem('merchantData'));

  const getBranchName = (ord) => {
    console.log(ord);
    console.log(branchSetts);
    let brnch = branchData?.branches.filter(brch => {

      let settUsr = branchSetts.filter(st => st.merchantCode == ord.userId
      )[0];
      console.log('settUsr', settUsr);

      if (settUsr && (brch.id == settUsr.userId)) {
        return brch;
      }
    })[0];
    return brnch && (brnch.firstName + ' ' + brnch.lastName);

  }

  const getMerchName = (ord) => {
    try {
      let setUsr = settings.find(st => st.merchantCode == ord.userId);
      if (!setUsr) return 'No Settings';

      let merch = allUsers.find(usr => usr.id == setUsr.userId);
      if (!merch) return 'No User';

      return merch.firstName + ' ' + merch.lastName;
    } catch (error) {
      console.error('Error getting merchant name:', error);
      return 'Error';
    }
  }

  return (
    <div className="main_dash">
      <div className="welcome-container">
        <h4 className="welcome-heading">Welcome!</h4>
        {userData && userData.role.toUpperCase() == "FRANCHISE-ADMIN" && !branchId && (
          <button className="member-btn" onClick={() => navigate('/members')}>
            + Add New Branch
          </button>
        )}
        {userData && userData.role.toUpperCase() == "FRANCHISE-ADMIN" && branchId && (
          <button className="member-btn" onClick={handleCloneMenu}>
            Clone Master Copy
          </button>

        )}

      </div>

      {userData && userData.role.toUpperCase() === "SUPER-ADMIN" && (
        <div className="item_list branch-info-container">
          {/* Tabs and Button Container */}
          <Box sx={{
            borderBottom: 1,
            borderColor: 'divider',
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
            width: '100%',
            flexWrap: 'wrap'
          }}>
            <Box sx={{ flex: 1, display: 'flex', justifyContent: 'center' }}>
              <Tabs
                value={merchantTab}
                onChange={(e, newValue) => setMerchantTab(newValue)}
                variant="scrollable"
                scrollButtons="auto"
                centered
                sx={{
                  '& .MuiTab-root': {
                    minWidth: { xs: '120px', sm: '150px', md: '200px' },
                    fontSize: { xs: '0.75rem', sm: '0.875rem', md: '1rem' },
                    padding: { xs: '8px 12px', sm: '10px 16px', md: '12px 20px' }
                  }
                }}
              >
                <Tab label={`Merchants (${allUsers.filter(usr => {
                  const userSet = settings.find(sett => sett.userId == usr.id);
                  return userSet && userSet.merchantCode && !usr.isIAM;
                }).length})`} />
                <Tab label={`Franchise (${allUsers.filter(usr => {
                  return usr.role && usr.role.toUpperCase() === "FRANCHISE-ADMIN";
                }).length})`} />
                <Tab label={`All Users (${allUsers.length})`} />
              </Tabs>
            </Box>
            <Box sx={{ padding: '0 16px', display: 'flex', alignItems: 'center', gap: '10px' }}>
              <TextField
                size="small"
                placeholder="Search"
                value={userSearch}
                onChange={(e) => setUserSearch(e.target.value)}
                sx={{ minWidth: 160 }}
              />
              <Button
                variant="contained"
                color="primary"
                onClick={() => navigate(memberPath)}
                sx={{ marginLeft: 'auto', backgroundColor: "#000000", color: "#ffffff", whiteSpace: 'nowrap' }}
              >
                Manage Users
              </Button>
            </Box>
          </Box>

          {/* Tab Panel 0: Merchants */}
          {merchantTab === 0 && (
            <Box sx={{ p: 3 }}>
              {(() => {
                const q = userSearch.trim().toLowerCase();
                const merchants = allUsers.filter(usr => {
                  const userSet = settings.find(sett => sett.userId == usr.id);
                  if (!(userSet && userSet.merchantCode && !usr.isIAM)) return false;
                  if (!q) return true;
                  const name = (usr.firstName + ' ' + usr.lastName).toLowerCase();
                  const email = (usr.email || usr.emailAddress || '').toLowerCase();
                  const mc = (userSet.merchantCode || '').toLowerCase();
                  return name.includes(q) || email.includes(q) || mc.includes(q);
                });
                return merchants.length > 0 ? (
                  <div
                    style={{
                      width: "100%",
                      overflow: "hidden",
                      overflowY: "auto",
                      maxHeight: "400px",
                      borderRadius: "8px",
                    }}
                  >
                    <table
                      style={{
                        width: "100%",
                        borderCollapse: "collapse",
                        fontSize: "16px",
                      }}
                    >
                      <thead>
                        <tr style={{ backgroundColor: "#f5f5f5" }}>
                          <th style={thStyle}>Name</th>
                          <th style={thStyle}>Email</th>
                          <th style={thStyle}>Address</th>
                          <th style={thStyle}>Merchant Code</th>
                          <th style={thStyle}>Joined</th>
                        </tr>
                      </thead>
                      <tbody>
                        {merchants.map((usr, index) => {
                          let userSet = settings.find(sett => sett.userId == usr.id);
                          return (
                            <tr key={index} style={{ borderBottom: "1px solid #ccc" }}>
                              <td style={tdStyle}>
                                <span style={{ fontWeight: "bold" }}>
                                  {usr.firstName + ' ' + usr.lastName}
                                </span>
                              </td>
                              <td style={tdStyle}>
                                {usr.email || usr.emailAddress || 'N/A'}
                              </td>
                              <td style={tdStyle}>
                                {usr.address || 'Address Not found'}
                              </td>
                              <td style={{ ...tdStyle, fontSize: "1.2em", fontWeight: "bold" }}>
                                {userSet && userSet.merchantCode}
                              </td>
                              <td style={{ ...tdStyle, fontSize: "0.8em" }} >
                                {(() => {
                                  const date = new Date(usr.createdDate);
                                  const day = date.getDate().toString().padStart(2, '0');
                                  const month = date.toLocaleString('en-US', { month: 'short' });
                                  const year = date.getFullYear().toString();
                                  return `${day}/${month}/${year}`;
                                })()}
                              </td>
                            </tr>
                          );
                        })}
                      </tbody>
                    </table>
                  </div>
                ) : (
                  <Typography style={{ textAlign: "center", padding: "20px" }}>
                    No merchants available.
                  </Typography>
                );
              })()}
            </Box>
          )}

          {/* Tab Panel 1: Franchise */}
          {merchantTab === 1 && (
            <Box sx={{ p: 3 }}>
              {(() => {
                const q = userSearch.trim().toLowerCase();
                const franchises = allUsers.filter(usr => {
                  if (!(usr.role && usr.role.toUpperCase() === "FRANCHISE-ADMIN")) return false;
                  if (!q) return true;
                  const name = (usr.firstName + ' ' + usr.lastName).toLowerCase();
                  const email = (usr.email || usr.emailAddress || '').toLowerCase();
                  const userSet = settings.find(sett => sett.userId == usr.id);
                  const mc = (userSet?.merchantCode || '').toLowerCase();
                  return name.includes(q) || email.includes(q) || mc.includes(q);
                });
                return franchises.length > 0 ? (
                  <div
                    style={{
                      width: "100%",
                      overflow: "hidden",
                      overflowY: "auto",
                      maxHeight: "400px",
                      borderRadius: "8px",
                    }}
                  >
                    <table
                      style={{
                        width: "100%",
                        borderCollapse: "collapse",
                        fontSize: "16px",
                      }}
                    >
                      <thead>
                        <tr style={{ backgroundColor: "#f5f5f5" }}>
                          <th style={thStyle}>Name</th>
                          <th style={thStyle}>Email</th>
                          <th style={thStyle}>Address</th>
                          <th style={thStyle}>Branches</th>
                          <th style={thStyle}>Merchant Code</th>
                          <th style={thStyle}>Joined</th>
                        </tr>
                      </thead>
                      <tbody>
                        {franchises.map((usr, index) => {
                          let userSet = settings.find(sett => sett.userId == usr.id);
                          const branchCount = franchiseBranchCounts[usr.id] !== undefined
                            ? franchiseBranchCounts[usr.id]
                            : '-';
                          return (
                            <tr key={index} style={{ borderBottom: "1px solid #ccc" }}>
                              <td style={tdStyle}>
                                <span style={{ fontWeight: "bold" }}>
                                  {usr.firstName + ' ' + usr.lastName}
                                </span>
                              </td>
                              <td style={tdStyle}>
                                {usr.email || usr.emailAddress || 'N/A'}
                              </td>
                              <td style={tdStyle}>
                                {usr.address || 'Address Not found'}
                              </td>
                              <td style={tdStyle}>
                                <span style={{ fontWeight: "bold", fontSize: "1.1em" }}>
                                  {branchCount}
                                </span>
                              </td>
                              <td style={{ ...tdStyle, fontSize: "1.2em", fontWeight: "bold" }}>
                                {(userSet && userSet.merchantCode) || (
                                  <button
                                    className="btn"
                                    style={{
                                      background: "#000",
                                      color: "#fff",
                                      border: "none",
                                      borderRadius: "5px",
                                      cursor: "pointer",
                                      padding: '5px 10px'
                                    }}
                                    onClick={() => generateMerchantCode(usr.id)}
                                  >
                                    Get Merchant Code
                                  </button>
                                )}
                              </td>
                              <td style={{ ...tdStyle, fontSize: "0.8em" }} >
                                {(() => {
                                  const date = new Date(usr.createdDate);
                                  const day = date.getDate().toString().padStart(2, '0');
                                  const month = date.toLocaleString('en-US', { month: 'short' });
                                  const year = date.getFullYear().toString();
                                  return `${day}/${month}/${year}`;
                                })()}
                              </td>
                            </tr>
                          );
                        })}
                      </tbody>
                    </table>
                  </div>
                ) : (
                  <Typography style={{ textAlign: "center", padding: "20px" }}>
                    No franchise users available.
                  </Typography>
                );
              })()}
            </Box>
          )}

          {/* Tab Panel 2: All Users */}
          {merchantTab === 2 && (
            <Box sx={{ p: 3 }}>
              {(() => {
                const q = userSearch.trim().toLowerCase();
                const filteredAll = allUsers.filter(usr => {
                  if (!q) return true;
                  const name = (usr.firstName + ' ' + usr.lastName).toLowerCase();
                  const email = (usr.email || usr.emailAddress || '').toLowerCase();
                  const userSet = settings.find(sett => sett.userId == usr.id);
                  const mc = (userSet?.merchantCode || '').toLowerCase();
                  return name.includes(q) || email.includes(q) || mc.includes(q);
                });
                return filteredAll.length > 0 ? (
                <div
                  style={{
                    width: "100%",
                    overflow: "hidden",
                    overflowY: "auto",
                    maxHeight: "400px",
                    borderRadius: "8px",
                  }}
                >
                  <table
                    style={{
                      width: "100%",
                      borderCollapse: "collapse",
                      fontSize: "16px",
                    }}
                  >
                    <thead>
                      <tr style={{ backgroundColor: "#f5f5f5" }}>
                        <th style={thStyle}>Name</th>
                        <th style={thStyle}>Email</th>
                        <th style={thStyle}>Address</th>
                        <th style={thStyle}>Merchant Code</th>
                        <th style={thStyle}>Joined</th>
                      </tr>
                    </thead>
                    <tbody>
                      {filteredAll.map((usr, index) => {
                        let userSet = settings.find(sett => sett.userId == usr.id);
                        // Find parent user for IAM accounts
                        let parentUser = null;
                        if (usr.isIAM && usr.parentUser) {
                          parentUser = allUsers.find(u => u.id === usr.parentUser);
                        }
                        return (
                          <tr key={index} style={{ borderBottom: "1px solid #ccc" }}>
                            <td style={tdStyle}>
                              <span style={{ fontWeight: "bold" }}>
                                {usr.firstName + ' ' + usr.lastName}
                              </span>
                            </td>
                            <td style={tdStyle}>
                              {usr.isIAM
                                ? (usr.pin ? `PIN: ${usr.pin}` : 'N/A')
                                : (usr.email || usr.emailAddress || 'N/A')
                              }
                            </td>
                            <td style={tdStyle}>
                              {usr.isIAM && parentUser
                                ? (parentUser.firstName + ' ' + parentUser.lastName)
                                : (usr.address || 'Address Not found')
                              }
                            </td>
                            <td style={{ ...tdStyle, fontSize: "1.2em", fontWeight: "bold" }}>
                              {(userSet && userSet.merchantCode) || (usr.isIAM && '-') || (
                                <button
                                  className="btn"
                                  style={{
                                    background: "#000",
                                    color: "#fff",
                                    border: "none",
                                    borderRadius: "5px",
                                    cursor: "pointer",
                                    padding: '5px 10px'
                                  }}
                                  onClick={() => generateMerchantCode(usr.id)}
                                >
                                  Get Merchant Code
                                </button>
                              )}
                            </td>
                            <td style={{ ...tdStyle, fontSize: "0.8em" }} >
                              {(() => {
                                const date = new Date(usr.createdDate);
                                const day = date.getDate().toString().padStart(2, '0');
                                const month = date.toLocaleString('en-US', { month: 'short' });
                                const year = date.getFullYear().toString();
                                return `${day}/${month}/${year}`;
                              })()}
                            </td>
                          </tr>
                        );
                      })}
                    </tbody>
                  </table>
                </div>
              ) : (
                <Typography style={{ textAlign: "center", padding: "20px" }}>
                  {q ? `No users match "${userSearch}".` : 'No users available.'}
                </Typography>
              );
              })()}
            </Box>
          )}
        </div>
      )}

      {userData && userData.role.toUpperCase() === "FRANCHISE-ADMIN" && !branchId && <div className="item_list branch-info-container">
        <div className="branch-info-header">
          <h3>FRANCHISE SUMMARY </h3>

        </div>
        <div
          className="branch-info-wrapper"
          style={{
            display: "flex",
            gap: "20px",
            flexWrap: "wrap",
            alignItems: "center",
            justifyContent: "space-around",
            padding: "5px",
          }}
        >

          <CardContent>
            <Typography
              sx={{ fontSize: 20 }}
              color="text.secondary"
              gutterBottom
              className="branch-metric-label"
            >
              Total Branches <span style={{ fontSize: "1.8em", color: "#000" }}> {branchData.totalBranches}</span>

            </Typography>

            <Typography
              sx={{ fontSize: 20 }}
              color="text.secondary"
              gutterBottom
              className="branch-metric-label"
            >
              Previous month  <span style={{ fontSize: "1.8em", color: "#000" }}>{branchData.newBranchesLastMonth}</span>
            </Typography>


          </CardContent>

          <div style={{ width: "70%" }}>
            <Typography
              sx={{ fontSize: 20 }}
              color="text.secondary"
              gutterBottom
              className="branch-metric-label"
            >
              Branches List
            </Typography>
            <div
              style={{
                minWidth: "400px", // Adjust as needed
                overflow: "hidden",
                overflowY: "auto",
                maxHeight: "300px", // Limit the height of the table
                // border: "1px solid #ddd",
                borderRadius: "8px",
                // padding: "10px",
              }}
            >
              <table
                style={{
                  width: "100%",
                  borderCollapse: "collapse",
                  fontSize: "16px",

                }}
              >
                {false && <thead>
                  <tr>
                    <th style={thStyle}>Item Name</th>
                    <th style={thStyle}>Quantity Sold</th>
                    <th style={thStyle}>Price</th>
                  </tr>
                </thead>}
                <tbody>
                  {branchData?.branches?.length
                    ? branchData?.branches.map((branch, index) => {
                      let brnchSet = branchSetts.find(brs => branch.id == brs.userId);
                      console.log(brnchSet)
                      return (
                        <tr key={index} style={{ borderBottom: "1px solid #ccc", padding: '10px' }}>
                          <td ><span style={{ fontWeight: "bold" }}>{branch.firstName + ' ' + branch.lastName}</span></td>
                          <td style={{ maxWidth: "300px", wordBreak: 'wrap' }}>{branch.address || 'Address Not found'}</td>
                          <td style={{ fontSize: "1.2em", fontWeight: "bold", textAlign: "center" }}>{(brnchSet && brnchSet.merchantCode) || <button className="btn" style={{ background: "#000", color: "#fff", border: "none", borderRadius: "5px", cursor: "pointer", padding: '5px' }} onClick={() => generateMerchantCode(branch.id)}>
                            Get Merchant Code
                          </button>}</td>
                          <td >{branch.createdDate.split('T')[0]}</td>
                        </tr>
                      );
                    })
                    : "No Recent available"}
                </tbody>
              </table>
            </div>
          </div>

        </div>
      </div>}

      {userData && userData.role.toUpperCase() === "MULTIVENDOR-ADMIN" && (
        <div className="item_list branch-info-container">
          <div className="branch-info-header" style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
            <h3>VENDORS LINKED</h3>
            <button
              className="member-btn"
              onClick={() => setShowLinkModal(true)}
              style={{ padding: "8px 16px", fontSize: "14px" }}
            >
              + Link New Vendor
            </button>
          </div>
          <div className="branch-info-wrapper" style={{ padding: "20px" }}>
            {isLoadingLinked ? (
              <Typography style={{ textAlign: "center", padding: "20px" }}>
                 Loading linked vendors...
              </Typography>
            ) : linkedVendors.length > 0 ? (
              <div style={{ width: "100%", overflowX: "auto" }}>
                <table style={{ width: "100%", borderCollapse: "collapse", fontSize: "16px" }}>
                  <thead>
                    <tr style={{ backgroundColor: "#f5f5f5" }}>
                      <th style={{ ...thStyle, textAlign: "left" }}>Merchant Code</th>
                      <th style={{ ...thStyle, textAlign: "right" }}>Actions</th>
                    </tr>
                  </thead>
                  <tbody>
                    {linkedVendors.map((code, index) => (
                      <tr key={index} style={{ borderBottom: "1px solid #eee" }}>
                        <td style={{ ...tdStyle, textAlign: "left", fontWeight: "bold" }}>{code}</td>
                        <td style={{ ...tdStyle, textAlign: "right" }}>
                          <ButtonGroup variant="contained" size="small">
                            <Button
                              onClick={() => {
                                localStorage.setItem("merchantCode", code);
                                window.location.href = `/?merchantCode=${code}`;
                              }}
                              style={{ backgroundColor: "#000", color: "#fff" }}
                            >
                              View Dashboard
                            </Button>
                            <Button
                              color="error"
                              onClick={() => handleUnlinkVendor(code)}
                              title="Unlink Vendor"
                            >
                              <CloseIcon fontSize="small" />
                            </Button>
                          </ButtonGroup>
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            ) : (
              <div style={{ textAlign: "center", padding: "40px", color: "#666" }}>
                <p>No vendors linked. Click the button above to link a vendor.</p>
              </div>
            )}
          </div>
        </div>
      )}

      {/* Sale report */}
      <div >




        <div
          style={{
            display: "flex",

            flexWrap: "wrap",
            alignItems: "center",
            justifyContent: "space-between",
            padding: "5px",
          }}
        >
          <Card className="list" sx={{ minWidth: "247px", padding: "5px" }}>
            <CardContent>
              <Typography
                sx={{ fontSize: 20 }}
                color="text.secondary"
                gutterBottom
              >
                Today's Orders
              </Typography>
              <Typography variant="h5" component="div" sx={{ fontSize: 44 }}>
                {report && report.length}
              </Typography>
            </CardContent>
            {/* <CardActions>
            <Button size="small">Know More</Button>
          </CardActions> */}
          </Card>

          <Card className="list" sx={{ minWidth: "247px" }}>
            <CardContent>
              <Typography
                sx={{ fontSize: 20 }}
                color="text.secondary"
                gutterBottom
              >
                Total Amount
              </Typography>
              <Typography variant="h5" component="div" sx={{ fontSize: 44 }}>
                {report && formatter.format(report.reduce((sum, item) => item.orderType?.toLowerCase() === 'refund' ? sum - item.totalPrice : sum + item.totalPrice, 0)).replace('JMD', 'J$')}
              </Typography>
            </CardContent>
            {/* <CardActions>
            <Button size="small">Know More</Button>
          </CardActions> */}
          </Card>

          <Card className="list" sx={{ minWidth: "247px" }}>
            <CardContent>
              <Typography
                sx={{ fontSize: 20 }}
                color="text.secondary"
                gutterBottom
              >
                Cancelled Orders
              </Typography>
              <Typography variant="h5" component="div" sx={{ fontSize: 44 }}>
                {report && report.filter((item) => item.isCanceled === true).length}
              </Typography>
            </CardContent>
            {/* <CardActions>
            <Button size="small">Know More</Button>
          </CardActions> */}
          </Card>
        </div>
      </div>

      {/* Payment data summary */}
      <div
        style={{
          display: "flex",
          flexDirection: "row",
          justifyContent: "space-between",
          alignItems: "flex-start",
          gap: "20px",
          padding: "10px",
          flexWrap: "wrap", // Allow wrapping on smaller screens
        }}
      >
        <div className="item_list" style={{
          flex: "1 1 100%", // Full width on mobile
          minWidth: "300px",
          maxWidth: "100%"
        }}>
          <h3>{t({ id: "pay_mode_and_ord_type" })}</h3>
          <div
            style={{
              display: "flex",
              justifyContent: "space-evenly",
              alignItems: "center",
              gap: "10px",
              padding: "10px",
              flexWrap: "wrap", // Wrap charts on small screens
            }}
          >
            {/* Pie Chart */}
            <div
              style={{
                position: "relative",
                width: "100%",
                maxWidth: "300px",
                height: "220px",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                minWidth: "250px"
              }}
            >
              <Pie data={pieChartData} options={options} />
            </div>
            <div
              style={{
                position: "relative",
                width: "100%",
                maxWidth: "300px",
                height: "220px",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                minWidth: "250px"
              }}
            >
              <Pie data={orderTypePieChartData} options={orderOptions} />
            </div>
          </div>
        </div>

        <div className="item_list" style={{
          minHeight: "300px",
          flex: "1 1 100%", // Full width on mobile
          minWidth: "300px",
          maxWidth: "100%"
        }}>
          <h3>{t({ id: "recent_orders" })}</h3>
          <ul
            className="order_list"
            style={{
              alignItems: "center",
              gap: "10px",
              padding: "0 10px",
              listStyle: "none",
              margin: 0
            }}
          >
            {orderList && [...orderList].reverse().slice(0, 5).map((ord, index) => (
              <li
                key={index}
                style={{
                  display: "grid",
                  gridTemplateColumns: "repeat(auto-fit, minmax(120px, 1fr))", // Equal distribution
                  width: "100%",
                  padding: "10px 5px",
                  borderBottom: "1px solid #ccc",
                  gap: "10px",
                  alignItems: "center"
                }}
              >
                {userData && userData.role.toUpperCase() === "FRANCHISE-ADMIN" && (
                  <span style={{
                    fontSize: "0.9rem",
                    textAlign: "center"
                  }}>
                    {getBranchName(ord)}
                  </span>
                )}
                {userData && userData.role.toUpperCase() === "SUPER-ADMIN" && (
                  <span style={{
                    fontSize: "0.9rem",
                    textAlign: "center"
                  }}>
                    {getMerchName(ord)}
                  </span>
                )}
                <span style={{ textAlign: "center" }}>
                  {ord.orderType.toLowerCase() === "eat in" && (
                    <img
                      height="20px"
                      alt=""
                      width="20px"
                      src="/images/eat_in.png"
                    />
                  )}
                  {ord.orderType.toLowerCase() === "take away" && (
                    <img
                      height="20px"
                      width="20px"
                      alt=""
                      src="/images/take-out-2.png"
                    />
                  )}
                  {ord.orderType === "Table Order" && (
                    <img
                      height="30px"
                      width="30px"
                      alt=""
                      src="/images/tableOrder.png"
                    />
                  )}
                  {ord.orderType.toLowerCase() === "delivery" && (
                    <DeliveryDiningIcon
                      style={{ height: "30px", width: "30px" }}
                    />
                  )}
                  {ord.orderType.toLowerCase() === "pick up" && (
                    <img
                      height="30px"
                      width="30px"
                      alt=""
                      src="/images/pickup.png"
                    />
                  )}
                </span>
                <span style={{
                  fontWeight: "bold",
                  textAlign: "center"
                }}>
                  {'#' + ord.number}
                </span>
                <span style={{
                  fontWeight: "normal",
                  fontSize: "0.85em",
                  color: "#666",
                  textAlign: "center"
                }}>
                  {ord.orderItems?.map(item => item.name).join(', ')}
                </span>
                <span style={{
                  textAlign: "center",
                  fontWeight: "500"
                }}>
                  {formatter.format(ord.totalPrice).replace('JMD', 'J$')}
                </span>
                <span style={{
                  fontSize: "0.8em",
                  textAlign: "center",
                  color: "#666"
                }}>
                  {timeSince(new Date(ord.createdAt)) + ' ago'}
                </span>
              </li>
            ))}
          </ul>
        </div>
      </div>

      {/* Inventory Data Summary */}
      {/* Inventory Data Summary */}
      <div className="item_list branch-info-container">
        <div className="branch-info-header">
          <h3>Inventory</h3>
        </div>

        {/* Tabs */}
        <Box sx={{
          borderBottom: 1,
          borderColor: 'divider',
          display: 'flex',
          justifyContent: 'center',
          width: '100%'
        }}>
          <Tabs
            value={inventoryTab}
            onChange={(e, newValue) => setInventoryTab(newValue)}
            variant="scrollable"
            scrollButtons="auto"
            centered
            sx={{
              '& .MuiTab-root': {
                minWidth: { xs: '120px', sm: '150px', md: '200px' },
                fontSize: { xs: '0.75rem', sm: '0.875rem', md: '1rem' },
                padding: { xs: '8px 12px', sm: '10px 16px', md: '12px 20px' }
              }
            }}
          >
            <Tab label={`Below Limit (${inventoryMetrics?.belowLimit?.length})`} />
            <Tab label={`Almost Finished (${inventoryMetrics?.almostFinished})`} />
            <Tab label={`Near Expiry (${inventoryMetrics?.nearExpiry})`} />
          </Tabs>
        </Box>

        {/* Tab Panel 0: Below Expected Limit */}
        {inventoryTab === 0 && (
          <Box sx={{ p: 3 }}>
            {belowLimitItemsDetails?.length > 0 ? (
              <TableContainer component={Paper} sx={{ maxHeight: '300px', overflow: 'auto' }}>
                <Table aria-label="below limit items table">
                  <TableHead>
                    <TableRow>
                      <TableCell>Item Name</TableCell>
                      <TableCell align="right">Remaining Quantity</TableCell>
                      <TableCell align="right">Minimum Limit</TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {belowLimitItemsDetails?.map((item) => (
                      <TableRow
                        key={item.name}
                        sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
                      >
                        <TableCell component="th" scope="row">
                          {item.name}
                        </TableCell>
                        <TableCell align="right">{item.availableQnty}</TableCell>
                        <TableCell align="right">{item.minLimit}</TableCell>
                      </TableRow>
                    ))}
                  </TableBody>
                </Table>
              </TableContainer>
            ) : (
              <Typography style={{ textAlign: "center", padding: "20px" }}>
                No items currently below their expected limit.
              </Typography>
            )}
          </Box>
        )}

        {/* Tab Panel 1: Almost Finished */}
        {inventoryTab === 1 && (
          <Box sx={{ p: 3 }}>
            {almostFinishedItemsDetails?.length > 0 ? (
              <TableContainer component={Paper} sx={{ maxHeight: '300px', overflow: 'auto' }}>
                <Table aria-label="almost finished items table">
                  <TableHead>
                    <TableRow>
                      <TableCell>Item Name</TableCell>
                      <TableCell align="right">Remaining Quantity</TableCell>
                      <TableCell align="right">Minimum Limit</TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {almostFinishedItemsDetails?.map((item, index) => (
                      <TableRow
                        key={item.name + index}
                        sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
                      >
                        <TableCell component="th" scope="row">
                          {item.name}
                        </TableCell>
                        <TableCell align="right">{item.availableQnty}</TableCell>
                        <TableCell align="right">{item.minLimit}</TableCell>
                      </TableRow>
                    ))}
                  </TableBody>
                </Table>
              </TableContainer>
            ) : (
              <Typography style={{ textAlign: "center", padding: "20px" }}>
                No items are currently almost finished.
              </Typography>
            )}
          </Box>
        )}

        {/* Tab Panel 2: Near Expiry */}
        {inventoryTab === 2 && (
          <Box sx={{ p: 3 }}>
            {nearExpiryItemsDetails?.length > 0 ? (
              <TableContainer component={Paper} sx={{ maxHeight: '300px', overflow: 'auto' }}>
                <Table aria-label="near expiry items table">
                  <TableHead>
                    <TableRow>
                      <TableCell>Item Name</TableCell>
                      <TableCell>Expiry Date</TableCell>
                      <TableCell align="right">Remaining Quantity</TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {nearExpiryItemsDetails?.map((item, index) => (
                      <TableRow
                        key={item.name + index}
                        sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
                      >
                        <TableCell component="th" scope="row">
                          {item.name}
                        </TableCell>
                        <TableCell>
                          {item.expiryDate ? new Date(item.expiryDate).toLocaleDateString() : 'N/A'}
                        </TableCell>
                        <TableCell align="right">{item.availableQnty}</TableCell>
                      </TableRow>
                    ))}
                  </TableBody>
                </Table>
              </TableContainer>
            ) : (
              <Typography style={{ textAlign: "center", padding: "20px" }}>
                No items are currently near their expiry date.
              </Typography>
            )}
          </Box>
        )}
      </div>

      {/* Most popular items */}
      <div className="item_list">
        <h3>Popular & Sold Items</h3>

        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "flex-start",
            gap: "20px",
            padding: "20px 30px",
          }}
        >
          {/* Left Side: Most Ordered Item Images */}
          {false && <div
            style={{
              display: "grid",
              gridTemplateColumns: "repeat(auto-fill, minmax(180px, 1fr))", // Responsive grid with minimum size
              gap: "20px",
              width: "50%",
            }}
          >
            {mostOrderedItems.length
              ? mostOrderedItems.slice(0, 4).map((pro, index) => {
                return (
                  <div key={index} className="item-img-name">
                    <img
                      src={pro.image}
                      onError={imageOnErrorHandler}
                      style={{
                        height: "120px",
                        width: "100%",
                        objectFit: "cover", // Ensures images look good without stretching
                        borderRadius: "8px", // Rounded corners
                        boxShadow: "0 4px 6px rgba(0, 0, 0, 0.1)", // Adds shadow for better design
                      }}
                    />
                    <span
                      className="title-ellipsis"
                      style={{
                        fontWeight: "bold",
                        textAlign: "center", // Center the text under the image
                        display: "block",
                        marginTop: "8px", // Adds spacing between image and text
                        width: "100%",
                        overflow: "hidden", // Prevents overflow if name is too long
                        textOverflow: "ellipsis", // Handles long text with ellipsis
                        whiteSpace: "nowrap", // Prevents text wrapping
                      }}
                    >
                      {pro.name}
                    </span>
                  </div>
                );
              })
              : "No popular items"}
          </div>}

          {/* Right Side: Table for Most Ordered Items */}
          <div
            style={{
              width: "100%", // Adjust as needed
              overflowX: "auto",
              maxHeight: "300px", // Limit the height of the table
              // border: "1px solid #ddd",
              borderRadius: "8px",
              // padding: "10px",
            }}
          >
            <table
              style={{
                width: "100%",
                borderCollapse: "collapse",
                fontSize: "16px",
                boxShadow: "0 0 10px rgba(0, 0, 0, 0.05)",
              }}
            >
              <thead>
                <tr>
                  <th style={thStyle}>Item Name</th>
                  <th style={thStyle}>Quantity Sold</th>
                  <th style={thStyle}>Price</th>
                </tr>
              </thead>
              <tbody>
                {mostOrderedItems.length
                  ? mostOrderedItems.map((pro, index) => {
                    return (
                      <tr key={index}>
                        <td style={tdStyle}>{pro.name}</td>
                        <td style={tdStyle}>{pro.quantity}</td>
                        <td style={tdStyle}>
                          {formatter.format(pro.revenue).replace('JMD', 'J$')}
                        </td>
                      </tr>
                    );
                  })
                  : "No data available"}
              </tbody>
            </table>
          </div>
        </div>
      </div>

      {/* Menu Summary */}
      <div className="item_list">
        <h3>Menu Overview</h3>

        <div
          style={{
            display: "flex",
            gap: "5%",
            flexWrap: "wrap",
            alignItems: "center",
            justifyContent: "center",
            padding: "5px",
          }}
        >
          <Card className="list">
            <div className="cat_logo"></div>
            <div style={{ textAlign: "start" }}>
              <h5
                style={{ fontSize: "15px", color: "black", lineHeight: "0px" }}
              >
                Total Categories
              </h5>
              <p style={{ fontSize: "44px" }}>{categories}</p>
            </div>
          </Card>
          <Card className="list">
            <div className="item_logo"></div>
            <div style={{ textAlign: "start" }}>
              <h5
                style={{ fontSize: "15px", color: "black", lineHeight: "0px" }}
              >
                Total Products
              </h5>
              <p style={{ fontSize: "44px", lineHeight: "0px" }}>
                {products}
              </p>
            </div>
          </Card>
          <Card className="list">
            {<div className="order_logo"></div>}
            <div style={{ textAlign: "start" }}>
              <h5
                style={{ fontSize: "15px", color: "black", lineHeight: "0px" }}
              >
                Total Inventory
              </h5>
              <p style={{ fontSize: "44px", lineHeight: "0px" }}>
                {inventoryData?.length}
              </p>
            </div>
          </Card>
        </div>
      </div>

      {/* User Profile Dialog with iframe */}
      <Dialog
        open={userProfileDialogOpen}
        onClose={() => setUserProfileDialogOpen(false)}
        maxWidth="lg"
        fullWidth
        PaperProps={{
          style: {
            height: '90vh',
            maxHeight: '90vh'
          }
        }}
      >
        <DialogTitle>
          <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
            <Typography variant="h6">Add/Manage User</Typography>
            <IconButton
              aria-label="close"
              onClick={() => setUserProfileDialogOpen(false)}
              sx={{
                position: 'absolute',
                right: 8,
                top: 8,
                color: (theme) => theme.palette.grey[500],
              }}
            >
              <CloseIcon />
            </IconButton>
          </Box>
        </DialogTitle>
        <DialogContent dividers sx={{ p: 0, height: '100%' }}>
          <iframe
            src={`${window.location.origin}/members?token=${localStorage.getItem("token") || ""}`}
            style={{
              width: '100%',
              height: '100%',
              border: 'none',
              minHeight: '75vh'
            }}
            title="User Profile"
          />
        </DialogContent>
      </Dialog>

      {/* Link Vendor Modal */}
      <Dialog open={showLinkModal} onClose={() => setShowLinkModal(false)} maxWidth="sm" fullWidth>
        <DialogTitle>
          Link New Vendor
          <IconButton
            aria-label="close"
            onClick={() => setShowLinkModal(false)}
            sx={{ position: 'absolute', right: 8, top: 8 }}
          >
            <CloseIcon />
          </IconButton>
        </DialogTitle>
        <DialogContent dividers>
          <Box component="form" onSubmit={handleLinkVendor} sx={{ mt: 2 }}>
            <Typography variant="body2" sx={{ mb: 2, color: 'text.secondary' }}>
              Enter the Merchant Code of the vendor you wish to link to your account.
            </Typography>
            <TextField
              fullWidth
              label="Merchant Code"
              variant="outlined"
              value={merchantCodeToLink}
              onChange={(e) => setMerchantCodeToLink(e.target.value)}
              placeholder="e.g. M123456789"
              required
              autoFocus
              disabled={isLinking}
            />
          </Box>
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setShowLinkModal(false)} disabled={isLinking}>
            Cancel
          </Button>
          <Button
            onClick={handleLinkVendor}
            variant="contained"
            disabled={isLinking || !merchantCodeToLink}
            style={{ backgroundColor: "#000", color: "#fff" }}
          >
            {isLinking && <span className="spinner-border spinner-border-sm mr-1"></span>}
            Link Vendor
          </Button>
        </DialogActions>
      </Dialog>

      <ToastContainer />
    </div>
  );
};

export default Dashboard;
